import React from 'react';
import { Info as InfoIcon, CheckCircle as CheckCircleIcon } from '@material-ui/icons';

export const AUTOMATION_USER_ID = 28;
export const STATUS_PRICE_UPDATED = 5;

export const STATUS_ICONS = {
  0: <InfoIcon fontSize="medium" />, // Not updated - gray
  1: <InfoIcon fontSize="medium" />, // Available on Store - blue
  2: <InfoIcon fontSize="medium" />, // Unavailable on Store - red
  3: <InfoIcon fontSize="medium" />, // Out of Stock - orange/yellow
  4: <InfoIcon fontSize="medium" />, // Available online only - blue
  5: <CheckCircleIcon fontSize="medium" />, // Price updated - green (automation)
};

export const STATUS_OPTIONS = {
  0: 'Not updated',
  1: 'Available on Store',
  2: 'Unavailable on Store',
  3: 'Out of Stock',
  4: 'Available online only',
  5: 'Price updated',
};

/** Analyst-selectable statuses only (excludes 0 Not updated and 5 automation). */
export const MANUAL_STATUS_OPTIONS = {
  1: STATUS_OPTIONS[1],
  2: STATUS_OPTIONS[2],
  3: STATUS_OPTIONS[3],
  4: STATUS_OPTIONS[4],
};

export const STATUS_COLORS = {
  0: '#FFF', // Out of Date
  1: '#FFF', // Available
  2: '#FFF', // Unavailable
  3: '#FFF', // Out of Stock
  4: '#FFF', // Available online only
  5: '#FFF', // Price updated
};

export const BACKGROUND_STATUS_COLORS = {
  0: '#fb9eac', // Out of Date - light red
  1: '#f44336', // Available - light dark red
  2: '#787575', // Unavailable - light gray
  3: '#f3a72f', // Out of Stock - light orange
  4: '#2196F3', // Available online only - blue
  5: '#43a047', // Price updated - green
};

/**
 * Display name for ood_check edited_by. Status 5 / automation user → "Automation".
 * @param {string|null|undefined} editedBy - typically last_name from API
 * @param {{ statusId?: number, editedById?: number }} [opts]
 */
export function formatOodEditedBy(editedBy, opts = {}) {
  const statusId = opts.statusId != null ? Number(opts.statusId) : null;
  const editedById = opts.editedById != null ? Number(opts.editedById) : null;
  if (
    editedById === AUTOMATION_USER_ID ||
    statusId === STATUS_PRICE_UPDATED
  ) {
    return 'Automation';
  }
  return editedBy || '';
}
